// @flow
import styled from "styled-components";

export const ListBenchPlayers = styled.div`
	border-top: 3px solid #CAD2D8;
`;

export default ListBenchPlayers;